module.exports = __webpack_public_path__ + "static/media/map-provinces-joboffer.a3e1bb0b.svg";